
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cabins/[[...slug]]",
      function () {
        return require("private-next-pages/cabins/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cabins/[[...slug]]"])
      });
    }
  